import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=6e6036fc&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=6e6036fc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6036fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6036fc')) {
      api.createRecord('6e6036fc', component.options)
    } else {
      api.reload('6e6036fc', component.options)
    }
    module.hot.accept("./goodsDetail.vue?vue&type=template&id=6e6036fc&scoped=true", function () {
      api.rerender('6e6036fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/goodsListActive/components/goodsDetail.vue"
export default component.exports